import { createContext, useContext } from 'react';

export interface HeaderMetaConfigState {
  name: string;
  description: string;
  setInputValues: (values: Partial<{ name: string; description: string }>) => void;
}

export const HeaderMetaConfigContext = createContext<HeaderMetaConfigState | null>(null);

export function useHeaderMetaConfigContext() {
  return useContext(HeaderMetaConfigContext);
}
